import { render, staticRenderFns } from "./Percentage.vue?vue&type=template&id=52c96890&scoped=true&"
import script from "./Percentage.vue?vue&type=script&lang=js&"
export * from "./Percentage.vue?vue&type=script&lang=js&"
import style0 from "./Percentage.vue?vue&type=style&index=0&id=52c96890&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c96890",
  null
  
)

export default component.exports